import angular from 'angular';
import 'angular-ui-router';
import 'satellizer';
import Configs from '../../../configs/configs';
import Services from '../../../services/services';
import Resources from '../../../resources/resources';
import template from './passwordEdit.jade';

export class PasswordEditController {
  constructor($stateParams, $state, $filter, notify,  $http, api){
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.notify = notify;
    this.$http = $http;
    this.api = api;

    this.fields = [
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'password',
        expressionProperties: {
          "templateOptions.label": "'password' | translate"
        },
        templateOptions: {
          label: '',
          required: true,
          type: 'password'
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'password_confirmation',
        expressionProperties: {
          "templateOptions.label": "'password_confirmation' | translate"
        },
        templateOptions: {
          label: '',
          required: true,
          type: 'password'
        },
        extras: {validateOnModelChange: true},
        validators: {
          passwordConfirmation: {
            expression: function ($viewValue, $modelValue, scope) {
              let value = $modelValue || $viewValue;
              return value === scope.model.password;
            },
            message: 'password confirmation does not match'
          }
        }
      }
    ];

    this.token = this.$stateParams.token;
    this.validateToken();
  }

  update() {
    if (this.invalid || this.loading) {
      return;
    }

    this.$http.post(`${this.api.baseURL}/oauth/token/v2/update-password`, {
      password: this.user.password
    }, {
      headers: {
        'Authorization': `Bearer ${this.$stateParams.token}`,
        'Requested-From-Component': 'pepapi-frontend'
      },
      skipAuthorization: true
    })
      .then(() => {
        this.notify.success('updatedPassword');
        this.$state.go('login');
      })
      .catch(this.notify.apiError)
  }

  validateToken() {
    if (!this.token) {
      this.invalid = true;
      this.loading = false;
      return;
    }

    this.$http.get(`${this.api.baseURL}/oauth/token/forgot-password/validate-token`, {
      headers: {
        'Authorization': `Bearer ${this.token}`,
        'Requested-From-Component': 'pepapi-frontend'
      },
      skipAuthorization: true
    }).then(() => {
      this.invalid = false;
    }).catch(() => {
      this.invalid = true;
    }).finally(() => {
      this.loading = false;
    });
  }
}

export function PasswordEditComponent() {
  return {
    template,
    controller: PasswordEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
}

export default angular.module('password.edit', [
  Configs.name,
  Resources.name,
  Services.name,
])
  .directive('passwordEdit', PasswordEditComponent)


/** WEBPACK FOOTER **
 ** ./src/components/account/password/passwordEdit.js
 **/